import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';

import { AZURE_CA_URLS } from '../../../shared/enums/HttpStatusCodes';
import { GESTION_TICKETS_ENDPOINTS, NativeStorageNamesV2 } from '../../../shared/models/Constants';
import { TicketPromedio } from '../../../shared/models/TicketPromedio';
import { SharedServiceService } from '../../../shared/services/shared-service.service';
import { StorageData } from './../../../shared/services/utilities/storage-data.class';

@Injectable({
    providedIn: 'root'
})

export class TicketAverange {

    private storageTicketPromedio = NativeStorageNamesV2.TicketPromedio

    constructor(private shareService: SharedServiceService) { }

    public CalculaTicketPromedio = (): Observable<TicketPromedio[]> => from((StorageData.getDataStorage(this.storageTicketPromedio)));

    public CalculaTicketPromedioV2 = async () => {
        const ticketPromedio: TicketPromedio[] | null = await StorageData.getDataStorage(this.storageTicketPromedio)
        if (ticketPromedio) {
            return ticketPromedio[0].TicketPromedio
        } else {
            return null
        }
    }

    public nativeError = (bodega: number, nud: number, anio: number, mes: number): Observable<unknown> => {
        const getCalculaTicketPromedio = this.shareService.executeRequestByUser(GESTION_TICKETS_ENDPOINTS.post_calcula_ticket_promedio_v2, { ID_Bodega: bodega, NUD: nud, Year: anio, Month: mes }, this.shareService.getAzureCAUrl(AZURE_CA_URLS.GESTION_TICKETS));
        return getCalculaTicketPromedio;
    }
}
